import React from 'react';
import { getInvoiceUrl, useInvoice } from 'queries';
import { Link } from '@app/core';

interface Props {
  invoiceId?: string;
  nullOnLoading?: boolean;
}

export const InvoiceName = (props: Props) => {
  const { data: invoice } = useInvoice(props.invoiceId);

  if (!props.invoiceId) {
    return null;
  }

  if (!invoice) {
    return null;
  }
  const invoiceUrl = getInvoiceUrl(invoice);

  if (!invoiceUrl) {
    return <span>{invoice.name}</span>;
  }
  return (
    <Link href={invoiceUrl} target="_blank">
      {invoice.name}
    </Link>
  );
};
